import axios from 'axios';

const BITCOU_URL = process.env.REACT_APP_GRAPHQL_URL || "https://sandbox-bitcou.kindynos.com/query";
const BITCOU_KEY = process.env.REACT_APP_GRAPHQL_KEY || "b403e688-dbd5-4d5a-987f-657c6526ecf6";

let headers = {
    'x-api-key' : BITCOU_KEY  
  }

export async function query( query ) {
    try {
      
      let q = await axios.post(BITCOU_URL ,{query},{headers})
      return q.data.data
    } catch (e) {
      return false
    } 
}